import { getDatabase, ref, get, remove, update } from "firebase/database";

export const deleteJogo = async () => {
  try {
    const db = getDatabase();
    const presencaSnap = await get(ref(db, "presenca"));
    const presenca = presencaSnap.val() || {};
    const usersSnap = await get(ref(db, "users"));
    const users = usersSnap.val() || {};

    const updates: { [path: string]: any } = {};
    for (const uid in users) {
      updates[`users/${uid}/jogoContabilizado`] = false;
      updates[`users/${uid}/isTuesday`] = false;
      updates[`users/${uid}/penalidadeJogo`] = false;
    }

    for (const uid in presenca) {
      const userSnap = await get(ref(db, `users/${uid}`));
      const userData = userSnap.val();

      if (userData) {
        const totalJogos = userData.totalJogos || 0;

        updates[`users/${uid}/totalJogos`] =
          totalJogos > 0 ? totalJogos - 1 : 0;
      }
    }

    // Salva a lista atual antes de apagar
    updates["presencahistorico"] = presenca;

    await update(ref(db), updates);
    await remove(ref(db, "presenca"));
  } catch (error) {
    console.error("Erro ao deletar a lista:", error);
  }
};
